import React from 'react';
import { useRefinementList } from 'react-instantsearch-hooks-web';
import { FacetProps } from './types';
import { useFormat } from '@/helpers/hooks/useFormat';
import Checkbox from '@/components/atoms/project-builder/checkbox';

const BooleanFacet: React.FC<FacetProps> = ({ attribute, label }) => {
  const { formatMessage: formatProductMessage } = useFormat({ name: 'product' });

  const { items, refine } = useRefinementList({ attribute });

  return (
    <div>
      <div className="flex flex-col gap-[47px] py-[22px] lg:min-w-[340px]">
        {items
          .filter((term) => term.value === 'true' && term.count > 0)
          .map((term) => (
            <div key={term.label} className="flex items-center justify-between gap-[8px]">
              <div>
                {term.value === 'true' ? label : formatProductMessage({ id: 'regular', defaultMessage: 'Regular' })}
              </div>
              <div className="flex items-center gap-[12px]">
                <Checkbox
                  checked={term.isRefined}
                  onChange={() => refine(term.value)}
                  label={term.count?.toString()}
                  labelPosition="on-left"
                />
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default BooleanFacet;
